import { RotateCcw } from "lucide-react";

export function LandscapeWarning() {
  return (
    <div className="fixed inset-0 bg-slate-900 z-[9999] flex-col items-center justify-center gap-6 p-8 text-center hidden portrait:flex">
      <div className="w-24 h-24 rounded-full bg-primary/20 flex items-center justify-center">
        <RotateCcw className="w-12 h-12 text-primary animate-spin" style={{ animationDuration: "3s" }} />
      </div>
      <h2 className="text-2xl font-bold text-white">
        Gire o Tablet
      </h2>
      <p className="text-slate-400 max-w-sm">
        Para melhor experiência, utilize o tablet na posição horizontal (paisagem)
      </p>
      <div className="mt-4 flex items-center gap-2">
        <div className="w-16 h-10 border-2 border-primary rounded-lg flex items-center justify-center">
          <div className="w-2 h-2 rounded-full bg-primary" />
        </div>
        <span className="text-slate-500">→</span>
        <div className="w-10 h-16 border-2 border-slate-600 rounded-lg flex items-center justify-center opacity-50">
          <div className="w-2 h-2 rounded-full bg-slate-600" />
        </div>
      </div>
    </div>
  );
}
